import React from 'react';
import { useHistory } from 'react-router-dom';

import ListItemSupervisor from 'flow/components/ui-components/ListItemSupervisor';
import { routes } from 'flow/types/routes';

interface Props {
    isOpen: boolean;
}

/** The fixed entry at the top of the chat list, leading to the overview. */
const OverviewListItem = ({ isOpen }: Props) => {
    const history = useHistory();

    return (
        <div>
            <ListItemSupervisor
                marking={isOpen ? 'pageOpen' : undefined}
                onClick={() => history.push(routes['messages.overview'])}
            />
        </div>
    );
};

export default React.memo(OverviewListItem);
